import {useEffect, useRef} from "react";
import {useBlocker} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";

export default function ProfileNavigationGuard({dirty, saving, pendingTab = null, onKeep, onDiscard, onDiscardNavigation,
    titleKey = "ProfileUnsavedTitle", messageKey = "ProfileUnsavedMessage", waitKey = "ProfileWaitForSave"}) {
    const {t} = useTranslation();
    const blocker = useBlocker(dirty || saving);
    const resumed = useRef(null);
    useEffect(() => {
        // Clearing a draft and proceeding can render the old blocked snapshot once more.
        if (blocker.state === "blocked" && !dirty && !saving && resumed.current !== blocker.proceed) {
            resumed.current = blocker.proceed;
            blocker.proceed();
        }
    }, [blocker, dirty, saving]);
    useEffect(() => {
        if (!dirty && !saving) return undefined;
        const preventUnload = event => { event.preventDefault(); event.returnValue = ""; };
        window.addEventListener("beforeunload", preventUnload);
        return () => window.removeEventListener("beforeunload", preventUnload);
    }, [dirty, saving]);

    const keep = () => { if (blocker.state === "blocked") blocker.reset(); else onKeep(); };
    const discard = () => {
        if (blocker.state === "blocked") {
            resumed.current = blocker.proceed;
            onDiscardNavigation?.();
            blocker.proceed();
        }
        else onDiscard();
    };
    return <Dialog open={blocker.state === "blocked" || pendingTab !== null} aria-labelledby="profile-leave-title">
        <DialogTitle id="profile-leave-title">{t(titleKey)}</DialogTitle>
        <DialogContent>{t(saving ? waitKey : messageKey)}</DialogContent>
        <DialogActions>
            <Button onClick={keep}>{t("ProfileKeepEditing")}</Button>
            <Button color="error" disabled={saving} onClick={discard}>{t("ProfileDiscard")}</Button>
        </DialogActions>
    </Dialog>;
}
